import * as THREE from "three";

// One camera + lookAt waypoint per section, forming a forward journey along -Z.
export const WAYPOINTS = [
  { pos: [0, 22, 46], look: [0, 6, 0] }, // hero — descend from the sky
  { pos: [-7, 4.5, 12], look: [-7, 5.5, 4] }, // about — first holographic billboard
  { pos: [7, 7, -8], look: [7, 11, -16] }, // experience — the tower
  { pos: [0, 5.5, -30], look: [0, 5, -40] }, // projects — hologram card row
  { pos: [-5, 3.5, -56], look: [-5, 3.5, -63] }, // skills — server room
  { pos: [9, 2.4, -72], look: [9, 2.4, -76] }, // education — quiet corner panel
  { pos: [0, 9, -98], look: [0, 18, -108] }, // contact — communication tower
];

export function buildCumulativeFractions(weights) {
  const total = weights.reduce((a, b) => a + b, 0);
  const cum = [0];
  weights.forEach((w) => cum.push(cum[cum.length - 1] + w));
  return cum.map((c) => c / total);
}

function smoothstep(t) {
  return t * t * (3 - 2 * t);
}

const tmpPos = new THREE.Vector3();
const tmpLook = new THREE.Vector3();

export function sampleCameraPath(progress, fractions) {
  const n = WAYPOINTS.length;
  let seg = n - 2;
  for (let i = 0; i < n - 1; i++) {
    if (progress >= fractions[i] && progress <= fractions[i + 1]) {
      seg = i;
      break;
    }
  }
  const segStart = fractions[seg];
  const segEnd = fractions[seg + 1];
  const localT = segEnd > segStart ? (progress - segStart) / (segEnd - segStart) : 0;
  const t = smoothstep(Math.min(Math.max(localT, 0), 1));

  const a = WAYPOINTS[seg];
  const b = WAYPOINTS[Math.min(seg + 1, n - 1)];

  tmpPos.set(...a.pos).lerp(new THREE.Vector3(...b.pos), t);
  tmpLook.set(...a.look).lerp(new THREE.Vector3(...b.look), t);

  return { position: tmpPos.clone(), lookAt: tmpLook.clone(), segment: seg };
}
